/**
 * iOS Home Screen Widget — writes data to App Group shared storage.
 * Widget reads via WidgetKit (Swift). See Swift code in docs.
 *
 * Call updateWidgetData() after: health check, booking confirmed, workout completed.
 * No-op on non-iOS platforms.
 */
import { isNative, isIOS } from '../utils/platform';

const WIDGET_KEY = 'duofit_widget_data';

function getPreferencesPlugin() {
  return window.Capacitor?.Plugins?.Preferences || null;
}

export async function updateWidgetData({ readinessScore, readinessLevel, nextSessionTime, nextSessionTrainer, streakDays }) {
  if (!isNative || !isIOS) return;
  const prefs = getPreferencesPlugin();
  if (!prefs) return;

  await prefs.set({
    key: WIDGET_KEY,
    value: JSON.stringify({
      readinessScore, readinessLevel, nextSessionTime, nextSessionTrainer, streakDays,
      updatedAt: new Date().toISOString(),
    }),
  });

  // Trigger widget timeline refresh (if WidgetKit plugin available)
  try {
    const wk = window.Capacitor?.Plugins?.WidgetKit;
    if (wk) await wk.reloadAllTimelines();
  } catch {}
}

export async function getWidgetData() {
  if (!isNative) return null;
  const prefs = getPreferencesPlugin();
  if (!prefs) return null;
  const { value } = await prefs.get({ key: WIDGET_KEY });
  return value ? JSON.parse(value) : null;
}
